import { PendingBillsModel } from 'one-card-pendingbills-cerner';

/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 *Pending Bills Component
 * @param response has the backend
 * pending bills response
 * @param context has settings etc...
 */


export const TransformResponseCerner = (response: any, context: any) => {
 /**
     * @param result contains the transformed response
     */
    let pendingbills: PendingBillsModel = { totalpendingbills: 0, totalbalance: 0 };

    let result: any = {
        bills: pendingbills,
        error: undefined
   
    }
    if (response && response.length > 0) {
        let sbototalbalance = 0,
            sbototalpendingbal = 0,
            sbopendingbill: [],
            sbototalpendingbills = 0;
        let hbtotalbalance = 0,
            hbtotalpendingbal = 0,
            hbpendingbill: [],
            hbtotalpendingbills = 0;
        let pbtotalbalance = 0,
            pbtotalpendingbal = 0,
            pbtotalpendingbills = 0;
        let sbobilledamount = 0;
        let hbinsurancebalance = 0;
        let pbinsurancebalance = 0;
        let servicearea = "";
        let AccountName="";
        response.map((duedata: any) => {

                        if (duedata?.balanceDetails) {
                            duedata.balanceDetails.map((ele:any)=>{
                                sbobilledamount =   parseInt(ele.billedamount);
                                sbototalbalance = sbototalbalance +parseInt(ele.patientBalance);
                            })                         
                        }

                        if (!duedata?.serviceAreaName) {
                            servicearea = duedata?.serviceAreaName
                            AccountName=duedata?.AccountName
                        }
                        duedata.singleBillingDetails?.map((dueamount: any) => {
                            sbototalpendingbal = sbototalpendingbal + 1;
                            sbototalpendingbills = sbototalpendingbal
                        })
                       //  if (duedata?.HospitalBilling?.OutstandingAccount?.Accounts) {
                       //      hbinsurancebalance = hbinsurancebalance + duedata.HospitalBilling.OutstandingAccount.InsuranceBalance;
                       //      hbtotalbalance = hbtotalbalance + duedata.HospitalBilling.OutstandingAccount.PatientBalance;
                            
                       //      if (!servicearea) {
                       //          servicearea = duedata.ServiceArea?.Name
                       //      }
                       //      hbpendingbill = duedata.HospitalBilling.OutstandingAccount.Accounts;
   
                       //      hbpendingbill.map((dueamount: any) => {
                       //          hbtotalpendingbal = hbtotalpendingbal + 1;
                       //          hbtotalpendingbills = hbtotalpendingbal
                       //      })
                       //  }
   
                        if (duedata?.ProfessionalBilling?.TransactionSummary) {
                            pbinsurancebalance = pbinsurancebalance + duedata.ProfessionalBilling.TransactionSummary.InsuranceBalance;
                            pbtotalbalance = pbtotalbalance + duedata.ProfessionalBilling.TransactionSummary.PatientBalance;
                            if (!servicearea) {
                                servicearea = duedata.ServiceArea?.Name
                            }
                            if (duedata.ProfessionalBilling.TransactionSummary.Patients &&
                                duedata.ProfessionalBilling.TransactionSummary.Patients.length > 0) {
                                duedata.ProfessionalBilling.TransactionSummary.Patients.map((pat: any) => {
                                    if (pat.Visits &&
                                        pat.Visits.length > 0) {
                                        pat.Visits.map((visit: any) => {
                                            if (visit.Charges &&
                                                visit.Charges.length > 0) {
                                                visit.Charges.map((pbhb: any) => {
                                                    pbtotalpendingbal = pbtotalpendingbal + 1;
                                                    pbtotalpendingbills = pbtotalpendingbal
                                                })
                                            }
                                        })
                                    }
                                })
                            }
                        }
   
                
   
   
            
        })
        pendingbills['totalpendingbills'] = sbototalpendingbills  + pbtotalpendingbills;
        pendingbills['totalbalance'] = sbototalbalance  + pbtotalbalance;
        pendingbills['billedamount'] = sbobilledamount ;
        pendingbills['servicearea'] = servicearea;
        pendingbills['AccountName'] = AccountName;
    }
    result.bills = pendingbills;  
    return result;
}